<template>
  <b-form-row>
    <b-form-group class="col-12">
      <label for="componente">Componente</label>
      <b-form-input
        type="text"
        name="componente"
        v-model="selectedComponente.compuesto"
      >
      </b-form-input>
    </b-form-group>
    <b-form-group class="col-md-6">
      <label for="cas">No. Cas</label>
      <b-form-input
        type="text"
        name="cas"
        v-model="selectedComponente.cas"
      >
      </b-form-input>
    </b-form-group>
    <b-form-group class="col-md-6">
      <label for="porcentaje">Porcentaje</label>
      <b-input-group append="%">
        <b-form-input
          type="number"
          step="0.001"
          name="porcentaje"
          max="100"
          min="0"
          v-model="selectedComponente.porcentaje"
          v-validate="{
                  rules: {
                    required: true,
                    decimal: 3,
                    min_value: 0,
                    max_value: 100
                  }
                }"
        >
        </b-form-input>
      </b-input-group>
    </b-form-group>
  </b-form-row>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "ModalFormComponentes",
  computed: {
    ...mapState('fds_productos',[
      'selectedComponente'
    ]),
  }
}
</script>

<style scoped>

</style>
